module.exports = __webpack_public_path__ + "static/media/OSBM06.175b485d.jpg";